import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const LocationRoutes = [
  {
    path: '/locations',
    name: 'ListLocations',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'sucursal:list'
    }
  },
  {
    path: '/location/',
    name: 'CreateLocation',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'sucursal:create'
    }
  },
  {
    path: '/location/:id',
    name: 'UpdateLocation',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'sucursal:update'
    }
  },
  {
    path: '/location/view/:id',
    name: 'GetLocation',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'sucursal:get'
    }
  }
]
